import { InvoiceActivity, InvoiceStatus } from '../types'

type InvoiceDeliveryState = {
  status?: InvoiceStatus
  lastActivity?: InvoiceActivity
  sentManually?: boolean
}

/** True when the invoice was sent via app, marked sent manually, or is currently sending. */
export function isInvoiceSentToClient(invoice: InvoiceDeliveryState): boolean {
  if (invoice.sentManually) {
    return true
  }
  const activity = invoice.lastActivity
  return (
    activity === InvoiceActivity.EMAIL_SENT
    || activity === InvoiceActivity.EMAIL_VIEWED
    || activity === InvoiceActivity.EMAIL_ON_QUEUE
  )
}

export function canSendInvoiceToClient(invoice: InvoiceDeliveryState): boolean {
  if (invoice.status === InvoiceStatus.DRAFT) {
    return true
  }
  return !isInvoiceSentToClient(invoice)
}
